// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/drawing.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".common_animated-background_2PU5f {\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n}\n\n.common_custom-font-title_wvU-h {\n  font-family: \"Kavivanar\", cursive;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.common_monaco-editor_1yHk0, .common_monaco-editor_1yHk0 * {\n   font-family: 'JetBrains Mono', 'Consolas', 'Monaco', monospace !important;\n}", ""]);
// Exports
exports.locals = {
	"animated-background": "common_animated-background_2PU5f",
	"animatedBackground": "common_animated-background_2PU5f",
	"custom-font-title": "common_custom-font-title_wvU-h",
	"customFontTitle": "common_custom-font-title_wvU-h",
	"monaco-editor": "common_monaco-editor_1yHk0",
	"monacoEditor": "common_monaco-editor_1yHk0"
};
module.exports = exports;
